import { SettingsService } from '@starsoft/common/services/SettingsService';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

/**
 * Custom hook to get the pathname from the current URL in a Next.js application.
 *
 * @returns {string} - The pathname of the current URL.
 *
 * Example usage:
 * const pathname = useNextPathname();
 */
export function useNextPathname(): string {
  // Get the current path from the Next.js router
  const { asPath } = useRouter();

  // Memoize the computation of the pathname to optimize performance
  const pathname: string = useMemo(() => {
    // Create a new URL object using the current path and the deployment URL from settings
    const url = new URL(asPath, SettingsService.env.DEPLOY_URL);
    // Return the pathname of the URL
    return url.pathname;
  }, [asPath]); // Dependency array to recompute the pathname when asPath changes

  // Return the computed pathname
  return pathname;
}
